import { 
  Maximize2, Minimize2, Camera, Play, Pause, SkipForward, Save, 
  ZoomIn, ZoomOut, ScanSearch, Minus, Eye, EyeOff, CandlestickChart, 
  BarChart2, Layers, Trash2, Crosshair, Type, Magnet, Lock, 
  X, Pencil 
} from "lucide-react";

const ChartCandlestick = CandlestickChart;
const ChartNoAxesColumn = BarChart2;

export {
  Maximize2, Minimize2, Camera, Play, Pause, SkipForward, Save,
  ZoomIn, ZoomOut, ScanSearch, Minus, Eye, EyeOff, ChartCandlestick,
  ChartNoAxesColumn, Layers, Trash2, Crosshair, Type, Magnet, Lock,
  X, Pencil
};